import React from "react";
import MarketingNav from "../../components/MarketingNav";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import { Code2 } from "lucide-react";

const snippets = {
  Python: `import openai
openai.api_base = "https://gateway.sentry.lunar/v1"
openai.api_key = "$SENTRY_TOKEN"   # your Sentry bearer

openai.ChatCompletion.create(
    model="gpt-4",
    messages=[{"role": "user", "content": "Hello"}],
)  # transparently screened by Sentry`,
  "Node.js": `import OpenAI from "openai";

const client = new OpenAI({
  baseURL: "https://gateway.sentry.lunar/v1",
  apiKey: process.env.SENTRY_TOKEN,
});

await client.chat.completions.create({
  model: "gpt-4",
  messages: [{ role: "user", content: "Hello" }],
});`,
  Go: `import "github.com/sashabaranov/go-openai"

cfg := openai.DefaultConfig(os.Getenv("SENTRY_TOKEN"))
cfg.BaseURL = "https://gateway.sentry.lunar/v1"
client := openai.NewClientWithConfig(cfg)

client.CreateChatCompletion(ctx, openai.ChatCompletionRequest{
    Model:    "gpt-4",
    Messages: []openai.ChatCompletionMessage{{Role: "user", Content: "Hello"}},
})`,
  curl: `curl -X POST "$BACKEND/api/v1/gateway/evaluate" \\
  -H "Authorization: Bearer $SENTRY_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"prompt":"...","model":"gpt-4","provider":"openai"}'`,
};

export default function SdkPage() {
  const [tab, setTab] = React.useState("Python");
  return (
    <div>
      <SEO
        path="/sdk"
        title="SDKs · Python, Node.js, Go & curl"
        description="One-line integration. Point your existing OpenAI, Anthropic, or Google SDK at the Sentry Gateway and every call becomes policy-enforced, logged, and signed. Python, Node.js, Go, and raw curl examples."
        keywords="Sentry SDK, LLM proxy SDK, OpenAI governance proxy, Anthropic governance, LLM policy integration"
      />
      <MarketingNav />
      <section className="container-x py-16">
        <div className="max-w-3xl">
          <span className="chip chip-orange mb-6"><Code2 size={12}/> SDKs</span>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-navy">One line to screen every AI request.</h1>
          <p className="ink mt-4 text-lg">Point your existing SDK at Sentry's Gateway. Every call is now policy-enforced, logged, and signed.</p>
        </div>
        <div className="flex gap-2 mt-8">
          {Object.keys(snippets).map(k => (
            <button key={k} data-testid={`sdk-${k.toLowerCase()}`} onClick={() => setTab(k)}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition ${
                tab === k ? "bg-navy text-cream" : "bg-[#EFEAE1] text-navy hover:bg-[#e5dfd1]"
              }`}>{k}</button>
          ))}
        </div>
        <div className="mt-4 rounded-2xl bg-navy text-cream p-6">
          <pre className="font-mono text-sm overflow-x-auto whitespace-pre">{snippets[tab]}</pre>
        </div>
      </section>
      <Footer />
    </div>
  );
}
